:host {
  display: block;
  @include slotted-margins("*:not([slot])");
  box-sizing: border-box;
  z-index: 9;
}

.#{$prefix}layer-wrapper {
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  background-color: v(backgroundColor);
  color: v(color);
  z-index: 90;
  outline-style: none;
  width: 480px;
  // 96px position-bottom of contact-layer + 48px layer position - 2x48px margins
  max-height: calc(100vh - 96px);
  min-height: var(--minHeight);
  height: auto;

  @if variable-exists(contact-layer-default-box-shadow) {
    box-shadow: $contact-layer-default-box-shadow;
  }

  @include for-size(phone) {
    max-height: calc(100vh - 48px);
    width: 100%;
    min-height: unset;
    margin-top: 48px;
    bottom: -100%;
    position: absolute;
  }

  .#{$prefix}layer-content-wrapper {
    margin: -6px calc(32px + 32px) 32px 32px;
    overflow: auto;
    @include for-size(phone) {
      margin: -6px 24px 24px 24px;
    }
  }

  .#{$prefix}closingX {
    align-self: flex-end;
    cursor: pointer;
    margin-right: 16px;
    margin-top: 8px;
  }
}

.#{$prefix}visible {
  opacity: 1;
  visibility: visible;
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s, bottom 0.5s linear;
  pointer-events: all;

  @include for-size(phone) {
    bottom: 0;
  }
}

::slotted(*) {
  color: v(color);
}
